import React, { useRef, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

export default function Pagination({ incFunc, hasMore, className }) {
  const ref = useRef();
  const [inViewRef, inView] = useInView({ threshold: 0.5 });

  // Use `useCallback` so we don't recreate the function on each render - Could result in infinite loop
  const setRefs = useCallback(
    (node) => {
      ref.current = node;
      // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
      inViewRef(node);
    },
    [inViewRef]
  );

  useEffect(() => {
    inView && hasMore && incFunc();
  }, [inView]);

  return <div ref={setRefs} className={className}></div>;
}

Pagination.propTypes = {
  incFunc: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
};

Pagination.defaultProps = {
  incFunc: () => {
    return null;
  },
  hasMore: true,
};
